<template>
  <div class="container">
    <div class="content">
      <img src="./image/page1.png" alt="">
      <img v-if="hiddenBtn1" @click="hiddenBtn1 = false" src="./image/btn1.png" alt="">
      <img v-else src="./image/btn1-page.png" alt="">

      <img v-if="hiddenBtn2" @click="hiddenBtn2 = false" src="./image/btn2.png" alt="">
      <template v-else>
        <img src="./image/btn2-page.png" alt="">
        <div class="example">
          <div class="title">
            <p>米因AI技術已成功為<span>國泰人壽、上海建工以及中移動等國際大型企業提供專業服務，</span>當中已有非常多活生生的案例證實，利用米因AI技術拯救生命。</p>
          </div>
          <div class="case">
            <div>
              <img src="./image/case1.png" alt="">
              <div class="name">典型個人案例--S先生</div>
              <div class="text">根據S先生的身體數據和血液檢查結果，米因AI重症預警演算法向S先生…</div>
              <div class="btn" @click="$router.push('/caseS')">查看详情 {{ '>>' }}</div>
            </div>
            <div>
              <img src="./image/case2.png" alt="">
              <div class="name">典型個人案例--H先生</div>
              <div class="text">H先生是試點工地的管理人員，看到米因健康AI重症預警產品…</div>
              <div class="btn" @click="$router.push('/caseH')">查看详情 {{ '>>' }}</div>
            </div>
          </div>
        </div>
      </template>


      <img v-if="hiddenBtn3" @click="hiddenBtn3 = false" src="./image/btn3.png" alt="">
      <img v-else src="./image/btn3-page.png" alt="">


      <img src="./image/page2.png" alt="">
    </div>
    <div class="footer">

      <div class="primary" v-if="$store.state.firstUse" @click="confirmToBuy">開始AI體檢</div>
      <div class="primary" v-else @click="$router.push('/history')">開始AI體檢</div>
    </div>
    <van-popup v-if="isNew" v-model="isFirstMention" position="center">
      <div class="product-popup">
        <div class="product-popup-img">
          <img src="../../assets/images/myLink/new-user-popup.png" class="product-popup-img-png" alt="">

        </div>
        <div class="product-popup-title">新用戶福利</div>
        <div class="product-popup-content">
          <div class="product-popup-content-card">
            <div class="content-card-left">
              <div class="card-left-title">首次免費</div>
              <div>評估全部疾病風險：</div>
              <ol>
                <li>痛風</li>
                <li>心肌梗塞</li>
                <li>腦中風</li>
                <li>癌症</li>
              </ol>
            </div>
            <div class="content-card-right">
              <div class="card-right-text1">恭喜獲得</div>
              <div class="card-right-text2">新用戶專屬</div>
              <div class="card-right-text-time">{{ timeStr }}</div>
            </div>
          </div>
        </div>
        <div class="product-popup-action">
          <div @click="isFirstMention = false" class="close-btn">
            <img src="./image/btn.png" alt="">
          </div>
        </div>
        <div class="product-popup-close" @click="isFirstMention = false">
          <img src="./image/close.png" alt="">
        </div>
      </div>
    </van-popup>
    <van-popup class="question-mention-popup" v-model="showQuestionMention" position="center">
      <div class="question-mention-container">
        <div class="question-mention-title">溫馨提示</div>
        <ul>
          <li>你需要提供身體指標，例如身高、體重、腰圍、臀圍，建議即時測量以保證數據精准；</li>
          <li>同時還需要提供生化指標，包括：空腹血糖Glucose(Fasting)，糖化血色素HbA1c，總膽固醇Cholesterol
            Total，高密度膽固醇HDL-Cholesterol，低密度膽固醇LDL-Cholesterol，三酸甘油酯Triglycerides，尿酸Uric Acid；
          </li>
          <li>你需要提供以上7項生化指標中的<span class="red">至少一項</span>，提供的指標愈多，AI分析結果愈精准；
          </li>
          <li>你可以通過家用設備如血糖儀即時測量，也可翻閱最近1年的健檢報告獲取相關指標。</li>
        </ul>
        <div class="question-mention-btn" @click="$router.push('/pay')">我知道了</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { isFirstMention, setFirstMention } from '@/js/mention'

export default {
  name: 'CmhkH5Product',

  data () {
    return {
      closeDate: "",
      isNew: false,
      isFirstMention: false,
      timer: null,
      timeStr: "",
      hiddenBtn1: true,
      hiddenBtn2: true,
      hiddenBtn3: true,
      showQuestionMention: false,
    };
  },
  created () {
    const token = localStorage.getItem('access_token');
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const thirdPartyToken = params.get('thirdPartyToken');
    const lastToken = localStorage.getItem('thirdPartyToken')
    if (thirdPartyToken && thirdPartyToken === lastToken && token) {
      this.$store.commit('checkLogin', true)
    } else {
      localStorage.clear();
      this.$store.dispatch('exit')
      this.$router.push('/login');
      return
    }


    const closeDate = localStorage.getItem('closeDate')
    if (this.$store.state.firstFree && closeDate) {
      this.closeDate = closeDate
      this.isNew = true
      this.startTimer()
    } else {
      this.isNew = false
    }
  },

  mounted () {
    if (this.$store.state.firstFree) {

      if (isFirstMention()) {
        this.isFirstMention = true
        setFirstMention()
        console.log("第一次提醒");

      } else {
        this.isFirstMention = false
        console.log("不是第一次提醒");
      }
    }

  },

  beforeDestroy () {
    clearInterval(this.timer)
  },

  methods: {
    startTimer () {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        const now = Math.floor(new Date().getTime() / 1000)
        if (now < this.closeDate) {
          const leftSecond = this.closeDate - now
          if (leftSecond > 60 * 60 * 24) {
            const days = Math.ceil(leftSecond / (24 * 60 * 60))
            this.timeStr = `${days}天內有效`
          } else {
            const hours = Math.floor(leftSecond / (60 * 60))
            const minutes = Math.floor((leftSecond - hours * 60 * 60) / 60)
            const seconds = leftSecond - hours * 60 * 60 - minutes * 60
            this.timeStr = `${hours}:${minutes}:${seconds}后失效`
          }

        } else {
          clearTimeout(this.timer)
        }
      }, 1000)

    },
    confirmToBuy () {
      this.showQuestionMention = true
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto;

  .content {
    overflow: auto;
    font-weight: 400;
    font-size: 0.28rem;
    color: #3B4549;
    line-height: 0.52rem;
    text-align: center;
    font-style: normal;

    .example {
      padding: 0.3rem;

      .title {
        padding: 0.16rem;

        p {
          span {
            font-weight: bold;
          }
        }
      }

      .case {
        display: flex;
        align-items: center;
        justify-content: space-between;

        >div {
          flex: 1;

          .name {
            font-weight: 600;
            font-size: 0.28rem;
            color: rgba(9, 11, 24, 0.8);
            line-height: 0.4rem;
            text-align: left;
            font-style: normal;
          }

          .text {
            text-align: left;
          }

          .btn {
            width: 100%;
            text-align: right;
            font-weight: 500;
            font-size: 0.26rem;
            color: #6681FA;
            line-height: 0.36rem;
            text-align: right;
            font-style: normal;
          }

          >img {
            width: 100%;
          }

          &:first-child {
            margin-right: 0.24rem;
          }
        }
      }
    }

    img {
      width: 100%;
    }
  }

  .footer {
    height: 1.7rem;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    box-shadow: 0px -1px 5px rgba(0, 0, 0, 0.1);
    padding: 0.44rem 0.4rem;

    >div {
      border-radius: 1.5rem;
      font-weight: 400;
      font-size: 0.36rem;
      color: #222222;
      line-height: 0.44rem;
      text-align: center;
      font-style: normal;
      display: flex;
      align-items: center;
      justify-content: center;
    }



    .primary {
      flex: 1;
      height: 0.84rem;
      background: #6681FA;
      border-radius: 0.48rem;
      color: #FFFFFF;
    }
  }
}

.van-popup {
  background-color: transparent !important;
  overflow: visible !important;
}

.product-popup {
  position: relative;
  width: 6.4rem;
  height: 6.4rem;
  background: linear-gradient(180deg, #FF4548 0%, #FFE3BB 100%);
  border-radius: 0.28rem;
  border: 0.02rem solid #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;


  .product-popup-img {
    position: absolute;
    bottom: calc(100%);
    left: 0;
    width: 100%;
    height: 3rem;
    z-index: 0;
    overflow: hidden;

    img {
      width: 100%;

    }
  }

  .product-popup-title {
    height: 1.34rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: FanWunMing-TW, FanWunMing-TW;
    font-weight: 800;
    font-size: 0.6rem;
    color: #FFFFFF;
    line-height: 0.48rem;
    text-shadow: 0px 0px 0px rgba(0, 0, 0, 0.26);
    text-align: center;
    font-style: normal;
  }

  .product-popup-content {
    position: relative;
    width: 5.34rem;
    height: 2.84rem;


    .product-popup-content-card {
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: 0rem 0rem 0.16rem 0.16rem;
      background: linear-gradient(180deg, #EC8890 0%, #fff 40%, #fff 100%);
      box-shadow: 0rem 0.1rem 0.24rem 0rem rgba(193, 41, 34, 0.44);
      z-index: 9;
      display: flex;
      justify-content: space-between;
      padding: 0.3rem 0.18rem;

      >div {
        height: 100%;
      }

      .content-card-left {
        width: 60%;
        font-weight: 400;
        font-size: 0.24rem;
        color: #F80000;
        line-height: 0.4rem;
        text-align: left;
        font-style: normal;
        padding-right: 0.16rem;

        >div {
          margin: 0.16rem 0;
        }

        .card-left-title {
          font-family: FanWunMing-TW, FanWunMing-TW;
          font-weight: 800;
          font-size: 0.44rem;
          line-height: 0.48rem;
          letter-spacing: 1px;
          text-align: center;
          font-style: normal;
        }

        >ol {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-template-rows: 1fr 1fr;

          li {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            &::before {
              content: "";
              display: block;
              width: 0.16rem;
              height: 0.16rem;
              background: #F80000;
              border-radius: 50%;
              margin-right: 0.16rem;
            }
          }
        }
      }

      .content-card-right {
        position: relative;
        width: 40%;
        color: #510200;
        border-left: 0.06rem dotted #510200;
        padding-left: 0.16rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .card-right-text1 {
          font-weight: 500;
          font-size: 0.28rem;
          color: #510200;
          line-height: 0.4rem;
          text-align: left;
          font-style: normal;
        }

        .card-right-text2 {
          font-weight: 500;
          font-size: 0.36rem;
          color: #510200;
          line-height: 0.4rem;
          text-align: left;
          font-style: normal;
          white-space: nowrap;
        }

        .card-right-text-time {
          margin-top: 0.22rem;
          font-weight: 400;
          font-size: 0.28rem;
          color: #580906;
          line-height: 0.4rem;
          text-align: left;
          font-style: normal;
          white-space: nowrap;
        }
      }
    }


    &::before {
      position: absolute;
      left: -0.23rem;
      top: -0.2rem;
      content: "";
      display: block;
      width: 5.8rem;
      z-index: 0;
      height: 0.32rem;
      background: #D40C10;
      box-shadow: inset 0rem 0.02rem 0.02rem 0.04rem rgba(250, 219, 194, 1);
      border-radius: 0.16rem;
      border: 0.04rem solid #fadbc2;
      border-image: linear-gradient(270deg, rgba(250, 219, 194, 1), rgba(243, 181, 143, 1)) 0.04 0.04;
    }
  }

  .product-popup-action {
    padding-top: 0.56rem;
  }

  .product-popup-close {
    position: absolute;
    top: calc(100% + 1rem);
  }
}
</style>